__turbopack_context__.v({
  "fromInput": "styles-module__sa_XlG__fromInput",
  "input": "styles-module__sa_XlG__input",
  "inputContainer": "styles-module__sa_XlG__inputContainer",
  "inputWrapper": "styles-module__sa_XlG__inputWrapper",
  "title": "styles-module__sa_XlG__title",
  "toInput": "styles-module__sa_XlG__toInput",
});
